import { useCallback } from 'react';
import type { QueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import { READERS_TABLE_QUERY_KEY, READER_TAGS_CATALOG_QUERY_KEY } from '@/lib/readersCatalogQueryCache';
import { groupReaderTagsByGroup } from '@/lib/readerTagCatalogGrouping';
import { CatalogTagsCatalogModal } from '@/components/CatalogTagsCatalogModal/CatalogTagsCatalogModal';

export interface ReaderTagsCatalogModalProps {
  open: boolean;
  onClose: () => void;
}

export function ReaderTagsCatalogModal({ open, onClose }: ReaderTagsCatalogModalProps) {
  const onInvalidateAfterMutation = useCallback(async (qc: QueryClient) => {
    await qc.invalidateQueries({ queryKey: READER_TAGS_CATALOG_QUERY_KEY });
    await qc.invalidateQueries({ queryKey: READERS_TABLE_QUERY_KEY });
  }, []);

  return (
    <CatalogTagsCatalogModal
      open={open}
      onClose={onClose}
      title="Теги чтецов"
      queryKey={READER_TAGS_CATALOG_QUERY_KEY}
      fetchTags={() => api.readerTags.list()}
      tagApi={api.readerTags}
      onInvalidateAfterMutation={onInvalidateAfterMutation}
      groupTags={groupReaderTagsByGroup}
      catalogKind="reader"
      deleteGroupScopeNote="также у всех чтецов"
      deleteTagScopeNote="убран у всех чтецов"
    />
  );
}
